import React from 'react';

export interface ToggleProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  size?: 'sm' | 'md';
}

export const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  ({ label, size = 'md', className = '', ...props }, ref) => {
    const sizeClasses = {
      sm: 'h-5 w-9',
      md: 'h-6 w-11',
    };

    const dotSizeClasses = {
      sm: 'h-4 w-4',
      md: 'h-5 w-5',
    };

    const translateClasses = {
      sm: 'translate-x-4',
      md: 'translate-x-5',
    };

    return (
      <label className="flex items-center cursor-pointer">
        <div className="relative">
          <input
            ref={ref}
            type="checkbox"
            className="sr-only peer"
            {...props}
          />
          <div
            className={`${sizeClasses[size]} bg-gray-300 rounded-full peer peer-checked:bg-primary-600 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed transition-colors ${className}`}
          />
          <div
            className={`${dotSizeClasses[size]} absolute left-0.5 top-0.5 bg-white rounded-full transition-transform peer-checked:${translateClasses[size]}`}
          />
        </div>
        {label && <span className="ml-3 text-sm text-gray-700">{label}</span>}
      </label>
    );
  }
);

Toggle.displayName = 'Toggle';
